import { zYesno } from '@/utils';
import { z } from 'zod';
import { zLookup } from '@/utils/zodHelper';

export const UnitSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  is_active: z.boolean().optional(),
  city: zLookup(),
  acronym: z.string().max(7),
  division: z.array(zLookup()).optional(),
  sap_code: z.string(),
});

export const UnitSearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
  city: zLookup().optional(),
});

export type UnitSchemaType = z.infer<typeof UnitSchema>;
